'use es6';

import { forwardRef, memo } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
import MenuItemLabel from 'simple-menus-lib/components/menu/MenuItemLabel';
import MenuItemOptions from 'simple-menus-lib/components/menu/MenuItemOptions';
import menuDropTarget from 'simple-menus-lib/components/dnd/decorators/menuDropTarget';
import withVisibilityChecker from 'simple-menus-lib/components/menu/decorators/withVisibilityChecker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuItem = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    menuId,
    parentId,
    canDrop,
    isOver,
    isCollapsed,
    isVisible,
    hasChildren,
    readOnly,
    toggleCollapse,
    connectDropTarget
  } = props;
  const itemClassNames = classNames('simple-menus-menu-item', isOver && 'is--over' + (!canDrop ? " no--drop" : ""));
  return connectDropTarget( /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      ref: ref,
      children: /*#__PURE__*/_jsx("div", {
        className: itemClassNames,
        children: /*#__PURE__*/_jsx(UICardWrapper, {
          compact: true,
          className: "simple-menus-item-card-wrapper",
          children: /*#__PURE__*/_jsx(UIScrollContainer, {
            children: /*#__PURE__*/_jsx(UIDragHandle, {
              position: "start",
              children: /*#__PURE__*/_jsxs("div", {
                className: "simple-menus-menu-item-content",
                "data-test-id": "menu-item",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "menu-content-left",
                  style: {
                    display: !isVisible && 'none'
                  },
                  children: /*#__PURE__*/_jsx(MenuItemLabel, {
                    id: id,
                    hasChildren: hasChildren,
                    toggleCollapse: toggleCollapse,
                    isCollapsed: isCollapsed,
                    readOnly: readOnly
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "menu-content-right",
                  style: {
                    display: !isVisible && 'none'
                  },
                  children: /*#__PURE__*/_jsx(MenuItemOptions, {
                    id: id,
                    isVisible: isVisible,
                    parentId: parentId,
                    menuId: menuId,
                    readOnly: readOnly
                  })
                })]
              })
            })
          })
        })
      })
    })
  }));
}), (prevProps, nextProps) => {
  return !nextProps.isVisible || prevProps.id === nextProps.id && prevProps.menuId === nextProps.menuId && prevProps.parentId === nextProps.parentId && prevProps.canDrop === nextProps.canDrop && prevProps.isOver === nextProps.isOver && prevProps.isCollapsed === nextProps.isCollapsed && prevProps.isVisible === nextProps.isVisible && prevProps.hasChildren === nextProps.hasChildren && prevProps.readOnly === nextProps.readOnly;
});
MenuItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  canDrop: PropTypes.bool,
  isOver: PropTypes.bool,
  isCollapsed: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  hasChildren: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  toggleCollapse: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired
};
export default compose(menuDropTarget(), withVisibilityChecker())(MenuItem);